





















































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardSubAssesmen from "@/components/pemeriksaan/assesmen/CardSubAssesmen.vue";
import CardCatatanEdukasi from "@/components/pemeriksaan/assesmen/catatanedukasi/CardCatatanEdukasi.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import CardAsesmenGigiMulut from "@/components/pemeriksaan/assesmen/asesmengigi/CardAsesmenGigiMulut.vue";
import CardAsesmenDentalKhusus from "@/components/pemeriksaan/assesmen/asesmengigi/CardAsesmenDentalKhusus.vue";
import CardPrmrj from "@/components/pemeriksaan/assesmen/prmrj/CardPrmrj.vue";
import { storePrmrj } from "@/store/modules/prmrj";
import { storeCatatanEdukasi } from "@/store/modules/catatanedukasi";
import { storeAsesmenGigi } from "@/store/modules/asesmengigi";
import RegisterHf from "@/components/forms/RegisterHf.vue";
import storePanggilanLayanan from "@/store/modules/new/PanggilanLayanan";
import CardAssesmenKemoterapi from "../tabs/rekam-medis/CardAssesmenKemoterapi.vue";
import CardProtokolKemoterapi from "../tabs/rekam-medis/CardProtokolKemoterapi.vue";
import storeAsesmenKemoterapi from "@/store/modules/AsesmenKemoterapi";
import CatatanPemberianObatPage from "@/pages/pemeriksaan_ranap/CatatanPemberianObatPage.vue";
import McuImsTabPage from "@/pages/PemeriksaanPage/McuImsTabPage.vue";
import { storePasien } from "@/store/modules/pasien";
import CpptRalanPage from "@/components/soap/CpptRalanPage.vue";
import AskepRanapPage from "@/components/pemeriksaan/AskepRanapPage.vue";
import TransferInternalPage from "@/components/pti/TransferInternalPage.vue";
import LaporanOperasiPage from "@/pages/pemeriksaan_ranap/LaporanOperasiPage.vue";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import CardNihssAssessment from "@/components/pemeriksaan/tabs/rekam-medis/CardNihssAssessment.vue";
import FormulirAsesmenOkupasiTerapiTabPage from "@/components/pemeriksaan/tabs/rekam-medis/FormulirAsesmenOkupasiTerapiTabPage.vue";
import FormulirAsesmenOkupasiTerapi from "@/store/modules/FormulirAsesmenOkupasiTerapi";
import FormulirAsesmenTerapiWicaraTabPage from "@/components/pemeriksaan/tabs/rekam-medis/FormulirAsesmenTerapiWicaraTabPage.vue";
import FormulirAsesmenTerapiWicara from "@/store/modules/FormulirAsesmenTerapiWicara";
import FormulirAsesmenFisioterapiTabPage from "@/components/pemeriksaan/tabs/rekam-medis/FormulirAsesmenFisioterapiTabPage.vue";
import FormulirAsesmenFisioterapi from "@/store/modules/FormulirAsesmenFisioterapi";
import PenggunaanAlatReuseRanapTab from "@/components/pemeriksaan/alat-reuse/PenggunaanAlatReuseRanapTab.vue";
import BundlePpiPage from "@/components/pemeriksaan/bundle-ppi/BundlePpiPage.vue";
import IcuHcuPage from "@/components/pemeriksaan/icu-hcu/IcuHcuPage.vue";
import SkriningBunuhDiriPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningBunuhDiriPage.vue";
import AsesmenGeriatriPage from "@/components/pemeriksaan/assesmen/AsesmenGeriatriPage.vue";
import RekamAsuhanHemodialisisPage from "@/components/pemeriksaan/tabs/rekam-medis/rekam-asuhan-hemodialisis/RekamAsuhanHemodialisisPage.vue";
import MppPage from "@/pages/pemeriksaan_ranap/MppPage.vue";
import MonitoringTrombolisisList from "@/components/pemeriksaan/tabs/rekam-medis/MonitoringTrombolisis/MonitoringTrombolisisList.vue";
import { MPP_TAB } from "@/utils/ralanFormRegistry";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";
import { isHemodialisa, isKemoterapi } from "@/utils/unit";
import { isUsiaGeriatri } from "@/utils/usiaPasien";

@Component({
  components: {
    CardSubAssesmen,
    CardAsesmenGigiMulut,
    CardAsesmenDentalKhusus,
    CardPrmrj,
    CardCatatanEdukasi,
    RegisterHf,
    CardAssesmenKemoterapi,
    CardProtokolKemoterapi,
    CatatanPemberianObatPage,
    CpptRalanPage,
    AskepRanapPage,
    TransferInternalPage,
    LaporanOperasiPage,
    McuImsTabPage,
    CardNihssAssessment,
    FormulirAsesmenOkupasiTerapiTabPage,
    FormulirAsesmenTerapiWicaraTabPage,
    FormulirAsesmenFisioterapiTabPage,
    PenggunaanAlatReuseRanapTab,
    BundlePpiPage,
    IcuHcuPage,
    SkriningBunuhDiriPage,
    AsesmenGeriatriPage,
    RekamAsuhanHemodialisisPage,
    MppPage,
    MonitoringTrombolisisList
  }
})
export default class CardAssesmenV2 extends Vue {
  @Prop() register!: string;
  @Prop() copySoap!: object;
  @Prop() dataSoap!: object;
  @Prop() statusAsesmen!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) deepLink!: any;
  tab = "tab-soap";
  mppTab = MPP_TAB;

  modalRujukan: boolean;
  modalSpri: boolean;
  showBtn: boolean;
  showriwayat: boolean;
  param = {
    unit_id: this.stateuser.unit_id,
    reg: this.register,
    profesi: this.stateuser.profesi,
    id: this.stateuser.id
  };
  loadRegHF = false;

  tabs = [
    {
      name: "Laporan Operasi",
      href: "#tab-laporan-operasi",
      elemId: "tab-laporan-operasi",
      component: "LaporanOperasiPage",
      visibility: true,
      props: {
        isActive: this.tab === "tab-laporan-operasi"
      },
      onClick: () => {
        return true;
      }
    },
    {
      name: "Catatan Pemberian Obat",
      href: "#tab-catatan-pemberian-obat",
      elemId: "tab-catatan-pemberian-obat",
      component: "CatatanPemberianObatPage",
      visibility: true,
      props: {
        isActive: this.tab === "tab-catatan-pemberian-obat"
      },
      onClick: () => {
        // return true;
        this.getByRegister();
      }
    },
    {
      name: "Asuhan Keperawatan",
      href: "#tab-askep",
      elemId: "tab-askep",
      component: "AskepRanapPage",
      visibility: true,
      props: {
        isActive: this.tab === "tab-askep"
      },
      onClick: () => {
        return true;
      }
    },
    {
      name: "Penilaian NIHSS",
      href: "#tab-nihss",
      elemId: "tab-nihss",
      component: "CardNihssAssessment",
      visibility: true,
      props: {
        isActive: this.tab === "tab-nihss"
      },
      onClick: () => {
        return true;
      }
    },
    {
      name: "Transfer Internal",
      href: "#tab-transfer-internal",
      elemId: "tab-transfer-internal",
      component: "TransferInternalPage",
      visibility: true,
      props: {
        isActive: this.tab === "tab-transfer-internal",
        reload: true
      },
      onClick: () => {
        return true;
      }
    }
  ];

  mounted() {
    // Skip the statusAsesmen default when a universal-search deep link already
    // picked a tab (the deepLink watcher runs first, in created()).
    const dl = this.deepLink;
    if (dl && dl.topTab === "tab-assesmen" && dl.elemId) {
      return;
    }
    if (this.statusAsesmen == "1" && this.showAsesmenAwalRalanTab) {
      this.tab = "tab-assesmen";
    }
  }

  @Watch("tab")
  onTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  @Watch("statusAsesmen")
  changedStatus(v) {
    if (v == "1" && this.showAsesmenAwalRalanTab) {
      this.tab = "tab-assesmen";
    } else if (v == "2") {
      this.tab = "tab-reghf";
    }
  }

  showTab(val) {
    // console.log(val);
    this.tab = val;
  }

  // Universal-search deep link (PasienFlyingBar -> Pemeriksaan -> here): jump to
  // the requested inner tab. Guarded by topTab so the shared prop is ignored
  // unless the search targets the Rekam Medis (Asesmen) host.
  @Watch("deepLink", { immediate: true })
  onDeepLink(payload) {
    if (!payload || payload.topTab !== "tab-assesmen" || !payload.elemId) {
      return;
    }
    if (payload.elemId === "tab-assesmen" && !this.showAsesmenAwalRalanTab) {
      return;
    }
    this.tab = payload.elemId;
    this.runTabLoader(payload.elemId);
  }

  // Data loaders normally fired by each tab's @click; call the matching one so a
  // deep-linked tab is populated exactly as if the user had clicked it.
  runTabLoader(val: string) {
    const loaders: Record<string, () => void> = {
      "tab-soap": () => this.klikTabSoap(),
      "tab-assesmen": () => this.klikTabAssesmen(),
      "tab-reghf": () => this.loadRegHFRecord(),
      "tab-asesmen-kemo": () => this.klikAsesmenKemo(),
      "tab-asesmen-gigi-mulut": () => this.klikTabAsesmenGigiMulut(),
      "tab-prmrj": () => this.klikTabprmrj(),
      "tab-catatan-edukasi": () => this.klikCatatanEdukasi(),
      "tab-catatan-pemberian-obat": () => this.getByRegister(),
      "tab-asesmen-okupasi-terapi": () => this.klikAsesmenOkupasiTerapi(),
      "tab-asesmen-terapi-wicara": () => this.klikAsesmenTerapiWicara(),
      "tab-asesmen-fisioterapi": () => this.klikAsesmenFisioterapi()
    };
    const fn = loaders[val];
    if (fn) {
      fn();
    }
  }

  showTabRujukan(item) {
    // const items = {
    //   modalRujukan: item["modal"],
    //   tab: item["tab"]
    // };

    this.$emit("goTotabRujukan", item);
  }

  showTabResume(item) {
    this.$emit("goTotabResume", item);
  }

  showTabSkdp(item) {
    this.$emit("goTotabSkdp", item);
  }

  showTabSpri(item) {
    // this.modalSpri = item["modal"];
    // this.tab = item["tab"];
    const items = {
      modalSpri: item["modal"],
      tab: item["tab"]
    };

    this.$emit("goTotabSpri", items);
  }

  get stateuser() {
    return userModule.user;
  }

  get statepasien() {
    return storePasien.identitasPasien;
  }

  /**
   * Tab "Asesmen Awal Gigi & Rongga Mulut" ditampilkan untuk seluruh klinik
   * gigi: Gigi Umum (03) & Gigi Umum Sore (2I) plus subspesialis Bedah Mulut
   * (1A), Konservasi/Endodonsi (1B), Orthodonti (1C), Prosthodonti (1D), dan
   * Konservasi/Endodonsi Sore (1E). Konten OHI-S + Foto Klinis (dulu tab
   * terpisah "Asesmen Medis Khusus Dental", RM.RJ.GIGI.DK.01) kini digabung ke
   * dalam tab ini via CardAsesmenDentalKhusus.
   */
  get showAsesmenGigiMulutTab() {
    return ["03", "2I", "1A", "1B", "1C", "1D", "1E"].includes(
      this.stateuser.unit_id
    );
  }

  /**
   * Tab "Dokumentasi Kelainan Kulit" (RM.RJ.KULIT.DOK.01) ditampilkan untuk
   * Klinik Kulit & Kelamin: pagi (09) & sore (2G) — keduanya unit_group 09.
   */
  get panggilanDokter() {
    return storePanggilanLayanan.allPanggilan.find(
      item => item.unit_id == "02" && item.dr_id == "XXX"
    )?.dokter_call;
  }

  klikTabSoap() {
    // storeAssesmenRalan.actAsesmenAwal(this.param);
    const getparam = {
      unit_id: this.stateuser.unit_id,
      reg: this.register
    };
    storePemeriksaanFisikRalan.actPemeriksaanFisikRalan(getparam);
    // storeAssesmenRalan.actAsesmenAwal(getparam);
  }

  klikTabAssesmen() {
    storeAssesmenRalan.actAsesmenAwal(this.param);
  }
  klikAsesmenKemo() {
    storeAsesmenKemoterapi.getAsesmenKemoterapiByReg(this.register);
  }

  soap() {
    storeAssesmenRalan.actAsesmenAwal(this.param);
    this.tab = "tab-soap";
  }

  klikTabprmrj() {
    storePrmrj.actPrmrjByRM(this.rm);
    storePrmrj.actPrmrjByReg(this.param);
  }
  klikCatatanEdukasi() {
    storeCatatanEdukasi.actCatatanEdukasi(this.register);
  }
  klikTabAsesmenGigiMulut() {
    storeAsesmenGigi.actAsesmenGigiByReg(this.register);
  }
  klikAsesmenOkupasiTerapi() {
    FormulirAsesmenOkupasiTerapi.getByRegister(this.register);
  }
  klikAsesmenTerapiWicara() {
    FormulirAsesmenTerapiWicara.getByRegister(this.register);
  }
  klikAsesmenFisioterapi() {
    FormulirAsesmenFisioterapi.getByRegister(this.register);
  }
  loadRegHFRecord() {
    this.loadRegHF = true;
  }

  get showRegisterHF() {
    return this.stateuser.unit_group_id == "27";
  }

  async getByRegister() {
    await CatatanPemberianObatStore.getByRegister(this.register).then(() => {});
  }

  get showOkupasiTerapiTab() {
    return (
      this.stateuser.unit_group_id == "11" || this.stateuser.unit_id == "11"
    );
  }

  get showTerapiWicaraTab() {
    return this.showOkupasiTerapiTab;
  }

  get showFisioterapiTab() {
    return this.showOkupasiTerapiTab;
  }

  get showSkriningBunuhDiriTab() {
    return [this.stateuser.unit_id, this.stateuser.unit_group_id].some(
      kode => isHemodialisa(kode) || isKemoterapi(kode)
    );
  }

  get isUnitHemodialisa() {
    return [this.stateuser.unit_id, this.stateuser.unit_group_id].some(kode =>
      isHemodialisa(kode)
    );
  }

  get showAsesmenAwalRalanTab() {
    return !this.isUnitHemodialisa;
  }

  get showRekamAsuhanHdTab() {
    return this.isUnitHemodialisa;
  }

  get showMppTab() {
    return this.isUnitHemodialisa;
  }

  get showMonitoringTrombolisisTab() {
    return this.isUnitHemodialisa;
  }

  bukaTabDariForm(val: string) {
    this.tab = val;
    this.runTabLoader(val);
  }

  get showAsesmenGeriatriTab() {
    return isUsiaGeriatri(this.statepasien?.tgl_lahir);
  }

  // form MCU hanya muncul di Poli MCU (Klinik MCU — KODE/unit_group "2Q").
  get showMcuTab() {
    return (
      this.stateuser.unit_group_id == "2Q" || this.stateuser.unit_id == "2Q"
    );
  }

}
